<div class="brand-preview-container" [ngClass]="{'inForm': inForm}">
    <ng-container *ngIf="(chosenBrandDetails$ | async) as chosenBrandDetails">
        <section class="brand-preview-prefix" *ngIf="chosenBrandDetails.prefix">{{chosenBrandDetails.prefix}}</section>
        <section class="brand-preview-logo" *ngIf="chosenBrandDetails.logo"><img width="264" height="40" loading="lazy" [src]="chosenBrandDetails.logo" alt="chosen-brand-logo" decoding="async"/></section>
    </ng-container>
</div>
